
export default {
  name: 'AcademyBannerLogo',
}
